/** @type {import("@mui/material").SxProps<Theme>} */
import theme from '../../theme/theme';

const styles = {
  containerStyle: {
    maxWidth: { xs: 600, md: 'lg' },
  },
  scrollTop: {
    display: 'flex',
    width: 'fit-content',
    margin: '0 auto',
    cursor: 'pointer',
    color: theme.palette.primary.textColor3,
    alignItems: 'center',
  },
  primaryNavStyle: {
    navGrid: { display: 'flex' },
    containerGrid: {
      pt: 2,
    },
    accordion: {
      container: {
        mb: 1,
        boxShadow: 'none',
        borderBottom: '1px solid gray',
        borderRadius: 0,
        width: '100vw',
      },
      summary: {
        color: theme.palette.primary.textColor3,
        height: { sm: 38 },
      },
      details: { color: theme.palette.primary.textColor3 },
    },
  },
  secondaryNavStyle: {
    container: {
      display: 'flex',
      flexDirection: { xs: 'column', md: 'row' },
      flexWrap: { xs: 'no-wrap', md: 'wrap' },
      justifyContent: 'center',
      maxWidth: { xs: '100%', sm: '100%', md: '100%' },
    },
    link: {
      width: 'fit-content',
      color: theme.palette.primary.textColor3,
      p: { xs: 1.5, md: 1.5 },
      textAlign: { xs: 'left' },
    },
  },
  socialNavStyle: {},
  disclaimerStyle: {
    maxWidth: { xs: '100vw', sm: '60vw' },
    mr: 'auto',
    ml: 'auto',
    color: theme.palette.primary.textColor3,
    '& #ot-sdk-btn.ot-sdk-show-settings': {
      fontFamily: 'eirsans-light',
      fontSize: '1rem',
      lineHeight: '1.5rem',
      backgroundColor: theme.palette.primary.backgroundColor2,
      borderColor: theme.palette.primary.buttonColor,
      fontWeight: '700',
      borderWidth: '2px',
      borderStyle: 'solid',
      color: theme.palette.primary.buttonColor,
      marginBottom: '1rem',
      marginTop: '-1.5rem',
      borderRadius: '5px',
    },
  },
};

export default styles;
